<template>
  <el-config-provider :locale="localeStore.elementPlusLocalization">
    <AppLayout />
  </el-config-provider>
</template>

<script setup lang="ts">
import AppLayout from "@/components/layout/AppLayout.vue";
import Config from "@/common/config";
import { onMounted } from "vue";
import { useFavicon } from "@vueuse/core";
import { useLocaleStore } from "@/stores/locale";
import { ElConfigProvider } from "element-plus";

const localeStore = useLocaleStore();

// VueUse composables that register lifecycle hooks must run synchronously
// during component setup, not at module scope in main.ts.
useFavicon(Config.isCompass ? "/compass-icon.svg" : "/favicon.ico");

onMounted(() => {
  document.title = Config.isCompass
    ? Config.pageTitleCompass
    : Config.pageTitleEtc;
});
</script>

<style lang="scss">
@use "@/assets/styles/main.scss" as *;
</style>
